import { render } from "./PhoneNav.vue?vue&type=template&id=adbbaabc&scoped=true"
import script from "./PhoneNav.vue?vue&type=script&lang=js"
export * from "./PhoneNav.vue?vue&type=script&lang=js"

import "./PhoneNav.vue?vue&type=style&index=0&id=adbbaabc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adbbaabc"]])

export default __exports__